import { render, staticRenderFns } from "./GeneralTypesCrud.vue?vue&type=template&id=7f250f32&scoped=true&"
import script from "./GeneralTypesCrud.vue?vue&type=script&lang=js&"
export * from "./GeneralTypesCrud.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTypesCrud.vue?vue&type=style&index=0&id=7f250f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f250f32",
  null
  
)

component.options.__file = "GeneralTypesCrud.vue"
export default component.exports